import Vue, { PropType } from 'vue';

import { 決算期TableHeader } from '@/classes/common/決算期Utility';

export default Vue.extend({
  name: 'C決算期TableHeader',

  props: {
    list: {
      type: Array as PropType<決算期TableHeader[]>,
      required: true,
    },
  },

  methods: {
    replaceLfToBr(label: string): string {
      return label.replaceAll('\n', '<br />');
    },
  },
});
